module.exports = __webpack_public_path__ + "static/media/chatnew.b13ca394.svg";